import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, HomeIcon, BotIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  icon: ZapIcon,
  title: 'Sofort herunterladen',
  text: 'Schließe deinen Kauf ab und erhalte sofortigen Zugriff auf alle 100+ Schritt-für-Schritt-PDF-Anleitungen — kein Warten, kein Versand.'
}, {
  icon: HomeIcon,
  title: 'Einfache Materialien besorgen',
  text: 'Jedes Projekt nutzt Alltagsgegenstände, die du bereits zu Hause hast — Karton, Klebeband, Gummibänder, Flaschendeckel. Keine Sonderkäufe nötig.'
}, {
  icon: BotIcon,
  title: 'Gemeinsam bauen & lernen',
  text: 'Folge der bebilderten Anleitung mit deinem Kind und sieh zu, wie es echte funktionierende Roboter baut — und vor Stolz strahlt.'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-96" data-mp="14h1h4zhgej6t">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-97" data-mp="19aw6ojjqpsdt">
        <SectionHeading eyebrow="So funktioniert's" title={<>Vom Download zum ersten Roboter in 3 einfachen Schritten</>} subtitle="Keine technischen Kenntnisse, keine Spezialwerkzeuge, keine teuren Materialien. Einfach herunterladen, ein paar Dinge von zu Hause zusammensuchen und loslegen." data-id="element-98" data-mp="2rlnxhbsfgkxc" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-99" data-mp="2wkhaz47psbxi">
          {steps.map((s, i) => <motion.div key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative rounded-3xl border border-ink/10 bg-white p-8" data-id="element-100" data-mp="3abe3kv1n4t4k" data-mpi={i}>
              <span className="absolute -top-4 left-8 flex h-9 w-9 items-center justify-center rounded-full bg-ink font-display text-lg font-bold text-white" data-id="element-101" data-mp="1kzbycsc13oo8">
                {i + 1}
              </span>
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light text-brand" data-id="element-102" data-mp="3q0o4fawyun30">
                <s.icon className="h-7 w-7" aria-hidden="true" data-id="element-103" data-mp="2tuf2pxz7fpa" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-ink" data-id="element-104" data-mp="2rrfpfaxoa7w">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-105" data-mp="cs1qkt9hx5jw">
                {s.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}